module.exports = __webpack_public_path__ + "media/images/icons/outlined/appstore-add-47ecddc318f9fa584295f9a7daec65ac.svg";